import React from 'react'
import PropTypes from 'prop-types'
import Button from '@bufferapp/ui/Button'
import { grayDarker } from '@bufferapp/ui/style/colors'

import { Wrapper, Message } from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'message' implicitly has an 'any' ... Remove this comment to see the full error message
const DismissAllBanner = ({ message, onDismissAll }) => (
  <Wrapper>
    {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
    <Message size={14} weight={500} color={grayDarker}>
      {message}
    </Message>

    <Button
      type="secondary"
      onClick={onDismissAll}
      label="Dismiss All"
      size="small"
    />
  </Wrapper>
)

DismissAllBanner.propTypes = {
  message: PropTypes.string.isRequired,
  onDismissAll: PropTypes.func.isRequired,
}

DismissAllBanner.defaultProps = {}

export default DismissAllBanner
